export default __webpack_public_path__ + "static/cabin-tiny-home-2-people-2-d86f896ea46d24dba8c4faeca9c573d5.jpg";